import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetParentContentsQueryVariables = Types.Exact<{
  filters: Types.GetParentContentsInput;
}>;


export type GetParentContentsQuery = { parentContents?: { contents: Array<{ id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null } | {}> } | null };


export const GetParentContentsDocument = /*#__PURE__*/ gql`
    query getParentContents($filters: GetParentContentsInput!) {
  parentContents(filters: $filters) {
    contents {
      ... on PathContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on ExternalContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on ScormContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on CourseContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on ArticleContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on CheckinType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on SurveyContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on TaskContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on QuizContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on ExerciseType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on LiveEventContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on OfflineEventContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on ExternalEventContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on RecurringLiveEventContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on RecurringOfflineEventContentType {
        id
        name
        type
        cover {
          url
        }
      }
      ... on RecurringExternalEventContentType {
        id
        name
        type
        cover {
          url
        }
      }
    }
  }
}
    `;

export function useGetParentContentsQuery(options: Omit<Urql.UseQueryArgs<GetParentContentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetParentContentsQuery, GetParentContentsQueryVariables>({ query: GetParentContentsDocument, ...options });
};